import urls from './publicListingUrls.js';
export const { publicListingPath, publicListingCategory } = urls;
